var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"kt_scrolltop",staticClass:"scrolltop",attrs:{"id":"kt_scrolltop"}},[_c('i',{staticClass:"fas fa-arrow-up text-white"})])}
var staticRenderFns = []

export { render, staticRenderFns }